import { useState, useCallback } from 'react'

/**
 * Hook that provides clipboard copy with a transient "copied" state.
 * @param {number} [resetDelay=2000]
 */
export const useCopyToClipboard = (resetDelay = 2000) => {
  const [copied, setCopied] = useState(false)

  const copy = useCallback(
    async (text) => {
      try {
        await navigator.clipboard.writeText(text)
        setCopied(true)
        setTimeout(() => setCopied(false), resetDelay)
      } catch (err) {
        console.error('Clipboard write failed:', err)
      }
    },
    [resetDelay]
  )

  return { copied, copy }
}
